import React from 'react';
import { CurricularClass102023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass102023 />;
};

export default ExtraCurricularActivitiesPage;
